import { render, staticRenderFns } from "./roleRouteList.vue?vue&type=template&id=ddc61ef2&scoped=true&"
import script from "./roleRouteList.vue?vue&type=script&lang=js&"
export * from "./roleRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc61ef2",
  null
  
)

export default component.exports